//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { handleImgSize } from '@/common/utils/map_view_data'
export default {
    computed: {
        show_comment_img() {
            return this.item.details.reply_comment && this.item.details.reply_comment.photos_urls.length
        },
        is_consultant() {
            return this.item.details.reply_comment ? this.item.details.reply_comment.user.is_consultant : this.item.details.user.is_consultant
        },
        nickname() {
            return this.item.details.reply_comment ? this.item.details.reply_comment.user.nickname : this.item.details.user.nickname
        },
        head_img() {
            return this.item.details.reply_comment ? this.item.details.reply_comment.user.headimgurl : this.item.details.user.headimgurl
        },
        img_url() {
            return this.item.details.reply_comment ? handleImgSize(this.item.details.reply_comment.photos_urls[0], 336) :''
        },
        show_comment() {
            return this.item.message_type === 'comment_reply'
        },
        comment_cubject() {
            return this.item.message_type === 'comment_reply' ? '回复了你的楼盘评论' : '赞了你的楼盘评论'
        },
        comment_class() {
            return this.item.message_type === 'comment_reply' ? 'reply' : 'like'
        }
    },
    props: {
        item: Object
    }
}
